import type { Ref } from 'react';

import ActionButton from 'components/ActionButton';
import Message from 'components/Message';
import { formatTemplate } from 'utils/format';

export interface Props {
	onMessageClose: () => void;
	onRestore: () => Promise<void>;
	ref?: Ref<HTMLParagraphElement>;
	/** Has {{productName}} placeholder. */
	removedMessageText: string;
	restoreButtonText: string;
	/** Has {{productName}} placeholder. */
	restoredMessageText: string;
	status: 'removed' | 'restored';
	title: string | undefined;
}

export default function RemovedBasketRow({
	onMessageClose,
	onRestore,
	ref,
	removedMessageText,
	restoreButtonText,
	restoredMessageText,
	status,
	title,
}: Props) {
	const isRestored = status === 'restored';

	return (
		<div className="py-6 print:hidden">
			<Message
				variant={isRestored ? 'success' : 'neutral'}
				onClose={onMessageClose}
			>
				<p ref={ref} tabIndex={-1}>
					{formatTemplate(
						isRestored ? restoredMessageText : removedMessageText,
						{ productName: title },
					)}
				</p>
				{!isRestored && (
					<ActionButton
						size="sm"
						variant="cta"
						onClick={onRestore}
						className="mt-4"
					>
						{restoreButtonText}
					</ActionButton>
				)}
			</Message>
		</div>
	);
}
RemovedBasketRow.displayName = 'RemovedBasketRow';
